// extracted by mini-css-extract-plugin
export var divider = "_u0-0";
export var systemMessage = "_u0-1";